module.exports = __webpack_public_path__ + "f3e2bb18309f24d6d7a22320bbb90c3a.fbx";